(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["poppy-barmat-design-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('poppy-barmat-design-buttons')) {
    customElements.define(
      'poppy-barmat-design-buttons',
      class extends HTMLElement {
        connectedCallback() {
          this.toggleButton = this.querySelector('.poppy-barmat-design-buttons__toggle');
          if (!this.toggleButton || this.onToggle) return;
          this.setAttribute('data-collapsed', '');
          this.toggleButton.hidden = false;
          this.onToggle = () => {
            const expanded = this.toggleButton.getAttribute('aria-expanded') !== 'true';
            this.toggleAttribute('data-collapsed', !expanded);
            this.toggleButton.setAttribute('aria-expanded', String(expanded));
            this.toggleButton.textContent = expanded
              ? this.toggleButton.dataset.collapseLabel
              : this.toggleButton.dataset.expandLabel;
          };
          this.toggleButton.addEventListener('click', this.onToggle);
        }

        disconnectedCallback() {
          this.toggleButton?.removeEventListener('click', this.onToggle);
          this.onToggle = null;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["poppy-blade-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('poppy-blade-addon')) {

    customElements.define('poppy-blade-addon', class extends HTMLElement {

      connectedCallback() {

        if (document.readyState === 'loading') {

          this.readyHandler = () => this.setup();

          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });

        } else {

          this.setup();

        }

      }



      setup() {

        if (this.initialized || !this.isConnected) return;

        this.form = document.getElementById(this.dataset.formId);

        this.section = this.closest('product-info');

        this.mediaWrapper = this.section?.querySelector('.product__media-wrapper');

        if (!this.form || !this.section || !this.mediaWrapper) return;

        this.initialized = true;

        this.config = JSON.parse(this.querySelector('[data-blade-data]').textContent);

        this.choice = this.querySelector('[data-blade-choice]');

        this.mugChoice = this.querySelector('[data-mug-choice]');

        this.signChoice = this.querySelector('[data-sign-choice]');
        this.signSize = this.querySelector('[data-sign-size]');
        this.signMatch = this.querySelector('[data-sign-match]');
        this.signOptions = this.querySelector('[data-sign-options]');
        this.signDesigns = this.querySelector('[data-sign-designs]');
        this.signPrice = this.querySelector('[data-sign-price]');

        this.price = this.querySelector('[data-blade-price]');

        this.total = this.querySelector('[data-blade-total]');

        this.error = this.querySelector('[data-blade-error]');

        this.description = this.querySelector('[data-blade-description]');

        this.preview = this.querySelector('[data-blade-preview-template]').content.firstElementChild.cloneNode(true);

        this.mediaWrapper.prepend(this.preview);

        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.config.currency });

        this.syncHandler = () => this.sync();

        this.submitHandler = (event) => this.submit(event);

        this.section.addEventListener('change', this.syncHandler);

        this.section.addEventListener('input', this.syncHandler);

        this.form.addEventListener('submit', this.submitHandler, true);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {

          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {

            if (event.data.sectionId === this.dataset.sectionId) this.sync();

          });

        }

        this.hidden = false;

        this.sync();

      }



      disconnectedCallback() {

        document.removeEventListener('DOMContentLoaded', this.readyHandler);

        this.section?.removeEventListener('change', this.syncHandler);

        this.section?.removeEventListener('input', this.syncHandler);

        this.form?.removeEventListener('submit', this.submitHandler, true);

        this.unsubscribe?.();

        this.preview?.remove();

        this.section?.classList.remove('poppy-blade-selected');

        this.section?.classList.remove('poppy-blade-preview-active');

        this.initialized = false;

      }



      selection() {

        const data = new FormData(this.form);

        const variant = this.config.variants.find((item) => String(item.id) === String(data.get('id')));

        const number = variant?.sku?.match(/^BM-MIL-POP-D(\d+)-2026(?:\+[24]C)?$/)?.[1];

        const blade = this.config.blades.find((item) => item.sku === `BAR-MIL-POP-D${number}-2026`);

        const mugCount = Number(this.mugChoice.value);

        const mugSku = `MUG-MIL-POP-2026-D${number}${mugCount > 1 ? `-${mugCount}PK` : ''}`;

        const mug = mugCount ? this.config.mugs.find(item => item.sku === mugSku) : null;

        const signSelected = Boolean(this.signChoice?.checked);
        const signDesignName = this.querySelector('[data-sign-design]:checked')?.value;
        const sign = this.config.signs.find(item => this.signMatch?.checked
          ? item.sku === `METAL-${this.signSize?.value}-MIL-POP-D${number}-2026`
          : item.option1 === signDesignName && item.option2 === this.signSize?.value);
        return { data, variant, blade, mug, mugCount, number, sign, signSelected, quantity: Number(data.get('quantity') || 1) };

      }



      sync() {

        if (!this.initialized) return;

        const { variant, blade, mug, mugCount, number, sign, signSelected, quantity } = this.selection();
        const signTitle = sign ? `${sign.option1} / ${this.config.signSizeLabels[sign.option2] || sign.option2}` : '';

        const bladeSelected = this.choice.checked;

        const selected = bladeSelected || mugCount > 0 || signSelected;
        const mugSource = this.config.mugImages[number];
        const mugQuantityLabel = `${mugCount} ${mugCount === 1 ? this.config.strings.mugSingle : this.config.strings.mugPlural}`;
        this.updateChoiceThumbnail(
          '[data-blade-choice-preview]',
          Boolean(bladeSelected && variant?.available && blade?.available && blade.featured_image?.src),
          blade?.featured_image?.src,
          `${this.config.strings.preview}: ${variant?.option1 || ''}`,
          variant?.option1 || '',
          blade?.featured_image
        );
        this.updateChoiceThumbnail(
          '[data-mug-choice-preview]',
          Boolean(mugCount && variant?.available && mug?.available && mugSource),
          mugSource,
          mug?.title || '',
          mugQuantityLabel,
          { width: 2200, height: 2200 }
        );

        const available = Boolean(variant?.available && (!bladeSelected || blade?.available) && (!mugCount || mug?.available) && (!signSelected || sign?.available));

        this.choice.disabled = (!blade?.available && !bladeSelected) || Boolean(this.busy);

        this.mugChoice.disabled = Boolean(this.busy);
        if (this.signChoice) {
          this.signChoice.disabled = Boolean(this.busy);
          this.signSize.disabled = Boolean(this.busy);
          this.signMatch.disabled = Boolean(this.busy);
          this.signOptions.hidden = !signSelected;
          this.signDesigns.hidden = this.signMatch.checked;
          if (sign) {
            this.signPrice.textContent = `+${this.money.format(sign.price / 100)}`;
            const signImage = this.querySelector('[data-sign-selected-image]');
            if (sign.featured_image?.src) signImage.src = this.imageUrl(sign.featured_image.src, 480);
            signImage.removeAttribute('srcset');
            signImage.alt = `${this.config.strings.signLabel}: ${signTitle}`;
            this.querySelector('[data-sign-caption]').textContent = signTitle;
          }
        }

        this.description.textContent = this.config.strings.description;

        this.price.textContent = blade ? `+${this.money.format(blade.price / 100)}` : '';

        this.section.classList.toggle('poppy-blade-selected', selected);

        this.section.classList.toggle('poppy-blade-preview-active', selected && available);

        this.preview.hidden = !selected || !available;

        this.total.hidden = !selected;

        if (!selected) return;

        if (!available) {this.total.textContent = this.config.strings.unavailable; return;}

        const unitPrice = variant.price + (bladeSelected ? blade.price : 0) + (mugCount ? mug.price : 0) + (signSelected ? sign.price : 0);

        this.total.textContent = `${this.config.strings.setPrice} ${this.money.format(unitPrice / 100)}`;

        if (Number.isInteger(quantity) && quantity > 1) this.total.textContent += ` · ${this.money.format(unitPrice * quantity / 100)} ${this.config.strings.quantityTotal} ${quantity}`;

        const setImage = this.preview.querySelector('[data-set-image]');

        const bladeImage = this.preview.querySelector('[data-blade-image]');

        const mugImage = this.preview.querySelector('[data-mug-image]');

        setImage.src = variant.featured_image?.src || this.config.fallbackImage; setImage.alt = variant.title;

        bladeImage.hidden = !bladeSelected;

        if (bladeSelected && blade.featured_image?.src) {
          bladeImage.width = blade.featured_image.width;
          bladeImage.height = blade.featured_image.height;
          bladeImage.src = this.imageUrl(blade.featured_image.src, 800);
        }

        mugImage.hidden = !mugCount;

        this.preview.querySelector('[data-mug-layout-label]').hidden = !mugCount;

        if (mugCount) {mugImage.src = this.config.mugImages[number]; mugImage.alt = `${mug.title} – realistic 11oz ceramic mug`;}

        const signPreview = this.preview.querySelector('[data-sign-image]');
        if (signPreview) {
          signPreview.hidden = !signSelected;
          if (signSelected && sign.featured_image?.src) {
            signPreview.src = this.imageUrl(sign.featured_image.src, 800);
            signPreview.removeAttribute('srcset');
            signPreview.alt = `${this.config.strings.signLabel}: ${signTitle}`;
          }
        }

        const details = [variant.title];
        if (signSelected) details.push(`${this.config.strings.signLabel}: ${signTitle}`);

        if (bladeSelected) details.push(this.config.strings.preview);

        if (mugCount) details.push(`${mugCount} matching 11oz ceramic mug${mugCount > 1 ? 's' : ''}`);

        this.preview.querySelector('[data-preview-caption]').textContent = details.join(' + ');

      }



      updateChoiceThumbnail(selector, selected, source, alt, caption, dimensions) {
        const figure = this.querySelector(selector);
        if (!figure) return;
        figure.hidden = !selected;
        if (!selected) return;
        const image = figure.querySelector('[data-choice-image]');
        image.width = dimensions.width;
        image.height = dimensions.height;
        image.alt = alt;
        const url = this.imageUrl(source, 320);
        if (image.getAttribute('src') !== url) image.src = url;
        const label = figure.querySelector('[data-choice-caption]');
        label.textContent = caption;
        label.title = alt;
      }

      async submit(event) {

        if (!this.choice.checked && !Number(this.mugChoice.value) && !this.signChoice?.checked) return;

        event.preventDefault();

        event.stopImmediatePropagation();

        if (this.busy) return;

        this.error.hidden = true;

        const { data, variant, blade, mug, mugCount, sign, signSelected, quantity } = this.selection();

        if (mugCount && this.config.mugPreviewOnly) {this.showError(this.config.strings.mugPreview); return;}

        if (!variant?.available || (this.choice.checked && !blade?.available) || (mugCount && !mug?.available) || (signSelected && !sign?.available)) {

          this.showError(this.config.strings.unavailable);

          return;

        }

        if (!Number.isInteger(quantity) || quantity < 1) {

          this.showError(this.config.strings.quantityError);

          return;

        }

        const quantityInput = this.form.elements.namedItem('quantity');

        if (quantityInput?.reportValidity && !quantityInput.reportValidity()) return;

        const properties = {};

        for (const [key, value] of data.entries()) {

          const match = key.match(/^properties\[(.+)\]$/);

          if (match && typeof value === 'string' && value) properties[match[1]] = value;

        }

        const parent = { id: variant.id, quantity, properties };

        const sellingPlan = data.get('selling_plan');

        if (sellingPlan) parent.selling_plan = sellingPlan;

        const items = [parent];

        if (this.choice.checked) items.push({ id: blade.id, quantity, parent_id: variant.id });

        if (mugCount) items.push({ id: mug.id, quantity, parent_id: variant.id });

        if (signSelected) items.push({ id: sign.id, quantity, parent_id: variant.id });

        this.busy = true;

        const button = this.form.querySelector('[type="submit"]');

        const wasDisabled = button.disabled;

        button.disabled = true;

        button.setAttribute('aria-busy', 'true');

        this.sync();

        this.total.textContent = this.config.strings.adding;

        try {

          const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {

            method: 'POST',

            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

            body: JSON.stringify({ items })

          });

          const result = await response.json();

          if (!response.ok || result.status) throw new Error(result.description || result.message || this.config.strings.error);

          window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);

        } catch (error) {

          this.showError(error.message || this.config.strings.error);

          this.busy = false;

          button.disabled = wasDisabled;

          button.removeAttribute('aria-busy');

          this.sync();

        }

      }



      imageUrl(source, width) {
        const url = new URL(source, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.href;
      }

      showError(message) {

        this.error.textContent = message;

        this.error.hidden = false;

      }

    });

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["poppy-mug-design-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('poppy-mug-design-preview')) {
    customElements.define('poppy-mug-design-preview', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('product-info') || this.closest('[id^="MainProduct-"]');
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('[data-open-mug-preview]');
        this.changeHandler = () => this.sync();
        this.clickHandler = event => {
          if (event.target.closest('[data-open-mug-preview]')) {if (!this.dialog.open) this.dialog.showModal(); return;}
          if (event.target.closest('[data-close-mug-preview]') || event.target === this.dialog) {this.dialog.close(); return;}
          const card = event.target.closest('[data-mug-design]');
          const select = this.getSelect();
          if (!card || !select) return;
          select.value = card.dataset.mugDesign;
          select.dispatchEvent(new Event('change', {bubbles:true}));
          this.sync();
          this.dialog.close();
        };
        this.closeHandler = () => {if (this.openButton.isConnected) this.openButton.focus();};
        this.addEventListener('click', this.clickHandler);
        this.section?.addEventListener('change', this.changeHandler);
        this.dialog.addEventListener('close', this.closeHandler);
        this.sync();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.clickHandler);
        this.section?.removeEventListener('change', this.changeHandler);
        this.dialog?.removeEventListener('close', this.closeHandler);
        if (this.dialog?.open) this.dialog.close();
      }
      getSelect() {return this.section?.querySelector('select[name="options[Design]"]');}
      sync() {
        const selected = this.getSelect()?.value;
        const cards = [...this.querySelectorAll('[data-mug-design]')];
        const card = cards.find(item => item.dataset.mugDesign === selected);
        if (!card) return;
        const source = card.querySelector('img');
        const image = this.querySelector('[data-current-mug]');
        image.src = source.src; image.alt = `${selected} mug preview`;
        this.querySelector('[data-current-name]').textContent = selected;
        cards.forEach(item => item.setAttribute('aria-pressed', String(item === card)));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
